export const useIsProduction = () => location.host === 'qic.online'
